var map = {
	"./bn/404": [
		43896,
		3896
	],
	"./bn/404.json": [
		43896,
		3896
	],
	"./bn/address": [
		95128,
		5128
	],
	"./bn/address.json": [
		95128,
		5128
	],
	"./bn/agriExpert": [
		99955,
		5193
	],
	"./bn/agriExpert.json": [
		99955,
		5193
	],
	"./bn/askQuestion": [
		54081,
		4081
	],
	"./bn/askQuestion.json": [
		54081,
		4081
	],
	"./bn/bankKyc": [
		95619,
		5619
	],
	"./bn/bankKyc.json": [
		95619,
		5619
	],
	"./bn/bioticStress": [
		12860,
		2860
	],
	"./bn/bioticStress.json": [
		12860,
		2860
	],
	"./bn/campaign": [
		15124,
		5124
	],
	"./bn/campaign.json": [
		15124,
		5124
	],
	"./bn/cart": [
		67292,
		7292
	],
	"./bn/cart.json": [
		67292,
		7292
	],
	"./bn/cartInsurance": [
		7662,
		7662
	],
	"./bn/cartInsurance.json": [
		7662,
		7662
	],
	"./bn/cattleInsurance": [
		16165,
		6165
	],
	"./bn/cattleInsurance.json": [
		16165,
		6165
	],
	"./bn/common": [
		80923,
		923
	],
	"./bn/common.json": [
		80923,
		923
	],
	"./bn/crop": [
		47864,
		7864
	],
	"./bn/crop.json": [
		47864,
		7864
	],
	"./bn/cropGuide": [
		92774,
		393
	],
	"./bn/cropGuide.json": [
		92774,
		393
	],
	"./bn/cropProblem": [
		7649,
		7649
	],
	"./bn/cropProblem.json": [
		7649,
		7649
	],
	"./bn/cropProblems": [
		22512,
		2512
	],
	"./bn/cropProblems.json": [
		22512,
		2512
	],
	"./bn/hospicash": [
		55050,
		5050
	],
	"./bn/hospicash.json": [
		55050,
		5050
	],
	"./bn/idKyc": [
		77338,
		7338
	],
	"./bn/idKyc.json": [
		77338,
		7338
	],
	"./bn/insurance": [
		33244,
		3244
	],
	"./bn/insurance.json": [
		33244,
		3244
	],
	"./bn/kyc": [
		17153,
		7153
	],
	"./bn/kyc.json": [
		17153,
		7153
	],
	"./bn/language": [
		3788,
		3788
	],
	"./bn/language.json": [
		3788,
		3788
	],
	"./bn/location": [
		6853,
		6853
	],
	"./bn/location.json": [
		6853,
		6853
	],
	"./bn/login": [
		34785,
		4785
	],
	"./bn/login.json": [
		34785,
		4785
	],
	"./bn/main": [
		20043,
		43
	],
	"./bn/main.json": [
		20043,
		43
	],
	"./bn/mandi": [
		44335,
		4335
	],
	"./bn/mandi.json": [
		44335,
		4335
	],
	"./bn/nearbyDc": [
		1504,
		1504
	],
	"./bn/nearbyDc.json": [
		1504,
		1504
	],
	"./bn/news": [
		75857,
		5857
	],
	"./bn/news.json": [
		75857,
		5857
	],
	"./bn/order": [
		33756,
		3756
	],
	"./bn/order.json": [
		33756,
		3756
	],
	"./bn/payments": [
		78893,
		8893
	],
	"./bn/payments.json": [
		78893,
		8893
	],
	"./bn/posts": [
		65403,
		5403
	],
	"./bn/posts.json": [
		65403,
		5403
	],
	"./bn/prakshep": [
		31166,
		1166
	],
	"./bn/prakshep.json": [
		31166,
		1166
	],
	"./bn/prescription": [
		53258,
		3258
	],
	"./bn/prescription.json": [
		53258,
		3258
	],
	"./bn/productFeed": [
		76187,
		6187
	],
	"./bn/productFeed.json": [
		76187,
		6187
	],
	"./bn/products": [
		63730,
		3730
	],
	"./bn/products.json": [
		63730,
		3730
	],
	"./bn/satellite": [
		54385,
		4385
	],
	"./bn/satellite.json": [
		54385,
		4385
	],
	"./bn/shriProgram": [
		63346,
		3346
	],
	"./bn/shriProgram.json": [
		63346,
		3346
	],
	"./bn/soilTest": [
		64885,
		4885
	],
	"./bn/soilTest.json": [
		64885,
		4885
	],
	"./bn/sowingDate": [
		72015,
		2015
	],
	"./bn/sowingDate.json": [
		72015,
		2015
	],
	"./bn/store": [
		36733,
		6733
	],
	"./bn/store.json": [
		36733,
		6733
	],
	"./bn/termSheet": [
		64197,
		4197
	],
	"./bn/termSheet.json": [
		64197,
		4197
	],
	"./en/404": [
		29675,
		9675
	],
	"./en/404.json": [
		29675,
		9675
	],
	"./en/address": [
		46855,
		6855
	],
	"./en/address.json": [
		46855,
		6855
	],
	"./en/agriExpert": [
		77942,
		7942
	],
	"./en/agriExpert.json": [
		77942,
		7942
	],
	"./en/askQuestion": [
		6118,
		6118
	],
	"./en/askQuestion.json": [
		6118,
		6118
	],
	"./en/bankKyc": [
		48280,
		8280
	],
	"./en/bankKyc.json": [
		48280,
		8280
	],
	"./en/bioticStress": [
		10353,
		353
	],
	"./en/bioticStress.json": [
		10353,
		353
	],
	"./en/campaign": [
		96173,
		6173
	],
	"./en/campaign.json": [
		96173,
		6173
	],
	"./en/cart": [
		36789,
		6789
	],
	"./en/cart.json": [
		36789,
		6789
	],
	"./en/cartInsurance": [
		82233,
		2233
	],
	"./en/cartInsurance.json": [
		82233,
		2233
	],
	"./en/cattleInsurance": [
		11502,
		1502
	],
	"./en/cattleInsurance.json": [
		11502,
		1502
	],
	"./en/common": [
		28062,
		8062
	],
	"./en/common.json": [
		28062,
		8062
	],
	"./en/crop": [
		55401,
		5401
	],
	"./en/crop.json": [
		55401,
		5401
	],
	"./en/cropGuide": [
		80241,
		241
	],
	"./en/cropGuide.json": [
		80241,
		241
	],
	"./en/cropProblem": [
		85334,
		5334
	],
	"./en/cropProblem.json": [
		85334,
		5334
	],
	"./en/cropProblems": [
		75093,
		5093
	],
	"./en/cropProblems.json": [
		75093,
		5093
	],
	"./en/hospicash": [
		13941,
		3941
	],
	"./en/hospicash.json": [
		13941,
		3941
	],
	"./en/idKyc": [
		28409,
		8409
	],
	"./en/idKyc.json": [
		28409,
		8409
	],
	"./en/insurance": [
		99867,
		9867
	],
	"./en/insurance.json": [
		99867,
		9867
	],
	"./en/kyc": [
		74802,
		4802
	],
	"./en/kyc.json": [
		74802,
		4802
	],
	"./en/language": [
		92501,
		2501
	],
	"./en/language.json": [
		92501,
		2501
	],
	"./en/location": [
		44788,
		4788
	],
	"./en/location.json": [
		44788,
		4788
	],
	"./en/login": [
		50042,
		42
	],
	"./en/login.json": [
		50042,
		42
	],
	"./en/main": [
		34502,
		4502
	],
	"./en/main.json": [
		34502,
		4502
	],
	"./en/mandi": [
		18368,
		8368
	],
	"./en/mandi.json": [
		18368,
		8368
	],
	"./en/nearbyDc": [
		40537,
		537
	],
	"./en/nearbyDc.json": [
		40537,
		537
	],
	"./en/news": [
		19536,
		9536
	],
	"./en/news.json": [
		19536,
		9536
	],
	"./en/order": [
		97687,
		7687
	],
	"./en/order.json": [
		97687,
		7687
	],
	"./en/payments": [
		79388,
		9388
	],
	"./en/payments.json": [
		79388,
		9388
	],
	"./en/posts": [
		40328,
		7947
	],
	"./en/posts.json": [
		40328,
		7947
	],
	"./en/prakshep": [
		32695,
		2695
	],
	"./en/prakshep.json": [
		32695,
		2695
	],
	"./en/prescription": [
		76151,
		6151
	],
	"./en/prescription.json": [
		76151,
		6151
	],
	"./en/productFeed": [
		89668,
		9668
	],
	"./en/productFeed.json": [
		89668,
		9668
	],
	"./en/products": [
		61587,
		1587
	],
	"./en/products.json": [
		61587,
		1587
	],
	"./en/satellite": [
		26686,
		6686
	],
	"./en/satellite.json": [
		26686,
		6686
	],
	"./en/shriProgram": [
		51761,
		6523
	],
	"./en/shriProgram.json": [
		51761,
		6523
	],
	"./en/soilTest": [
		63804,
		3804
	],
	"./en/soilTest.json": [
		63804,
		3804
	],
	"./en/sowingDate": [
		62774,
		2774
	],
	"./en/sowingDate.json": [
		62774,
		2774
	],
	"./en/store": [
		14206,
		4206
	],
	"./en/store.json": [
		14206,
		4206
	],
	"./en/termSheet": [
		44574,
		4574
	],
	"./en/termSheet.json": [
		44574,
		4574
	],
	"./gu/404": [
		51692,
		1692
	],
	"./gu/404.json": [
		51692,
		1692
	],
	"./gu/address": [
		67668,
		7668
	],
	"./gu/address.json": [
		67668,
		7668
	],
	"./gu/agriExpert": [
		94572,
		2191
	],
	"./gu/agriExpert.json": [
		94572,
		2191
	],
	"./gu/askQuestion": [
		63117,
		3117
	],
	"./gu/askQuestion.json": [
		63117,
		3117
	],
	"./gu/bankKyc": [
		42287,
		2287
	],
	"./gu/bankKyc.json": [
		42287,
		2287
	],
	"./gu/bioticStress": [
		21912,
		1912
	],
	"./gu/bioticStress.json": [
		21912,
		1912
	],
	"./gu/campaign": [
		23672,
		3672
	],
	"./gu/campaign.json": [
		23672,
		3672
	],
	"./gu/cart": [
		66224,
		6224
	],
	"./gu/cart.json": [
		66224,
		6224
	],
	"./gu/cartInsurance": [
		96074,
		6074
	],
	"./gu/cartInsurance.json": [
		96074,
		6074
	],
	"./gu/cattleInsurance": [
		67449,
		7449
	],
	"./gu/cattleInsurance.json": [
		67449,
		7449
	],
	"./gu/common": [
		60511,
		511
	],
	"./gu/common.json": [
		60511,
		511
	],
	"./gu/crop": [
		71100,
		1100
	],
	"./gu/crop.json": [
		71100,
		1100
	],
	"./gu/cropGuide": [
		77842,
		7842
	],
	"./gu/cropGuide.json": [
		77842,
		7842
	],
	"./gu/cropProblem": [
		43389,
		3389
	],
	"./gu/cropProblem.json": [
		43389,
		3389
	],
	"./gu/cropProblems": [
		50244,
		244
	],
	"./gu/cropProblems.json": [
		50244,
		244
	],
	"./gu/hospicash": [
		81622,
		1622
	],
	"./gu/hospicash.json": [
		81622,
		1622
	],
	"./gu/idKyc": [
		88582,
		8582
	],
	"./gu/idKyc.json": [
		88582,
		8582
	],
	"./gu/insurance": [
		38400,
		8400
	],
	"./gu/insurance.json": [
		38400,
		8400
	],
	"./gu/kyc": [
		16757,
		6757
	],
	"./gu/kyc.json": [
		16757,
		6757
	],
	"./gu/language": [
		28888,
		8888
	],
	"./gu/language.json": [
		28888,
		8888
	],
	"./gu/location": [
		95625,
		5625
	],
	"./gu/location.json": [
		95625,
		5625
	],
	"./gu/login": [
		99061,
		9061
	],
	"./gu/login.json": [
		99061,
		9061
	],
	"./gu/main": [
		3351,
		3351
	],
	"./gu/main.json": [
		3351,
		3351
	],
	"./gu/mandi": [
		8107,
		8107
	],
	"./gu/mandi.json": [
		8107,
		8107
	],
	"./gu/nearbyDc": [
		95636,
		5636
	],
	"./gu/nearbyDc.json": [
		95636,
		5636
	],
	"./gu/news": [
		24965,
		4965
	],
	"./gu/news.json": [
		24965,
		4965
	],
	"./gu/order": [
		45000,
		5000
	],
	"./gu/order.json": [
		45000,
		5000
	],
	"./gu/payments": [
		45641,
		5641
	],
	"./gu/payments.json": [
		45641,
		5641
	],
	"./gu/posts": [
		64927,
		4927
	],
	"./gu/posts.json": [
		64927,
		4927
	],
	"./gu/prakshep": [
		74290,
		4290
	],
	"./gu/prakshep.json": [
		74290,
		4290
	],
	"./gu/prescription": [
		19862,
		9862
	],
	"./gu/prescription.json": [
		19862,
		9862
	],
	"./gu/productFeed": [
		13023,
		3023
	],
	"./gu/productFeed.json": [
		13023,
		3023
	],
	"./gu/products": [
		33950,
		3950
	],
	"./gu/products.json": [
		33950,
		3950
	],
	"./gu/satellite": [
		83461,
		5842
	],
	"./gu/satellite.json": [
		83461,
		5842
	],
	"./gu/shriProgram": [
		174,
		174
	],
	"./gu/shriProgram.json": [
		174,
		174
	],
	"./gu/soilTest": [
		76569,
		6569
	],
	"./gu/soilTest.json": [
		76569,
		6569
	],
	"./gu/sowingDate": [
		44627,
		4627
	],
	"./gu/sowingDate.json": [
		44627,
		4627
	],
	"./gu/store": [
		41033,
		1033
	],
	"./gu/store.json": [
		41033,
		1033
	],
	"./gu/termSheet": [
		83065,
		3065
	],
	"./gu/termSheet.json": [
		83065,
		3065
	],
	"./hi/404": [
		14295,
		4295
	],
	"./hi/404.json": [
		14295,
		4295
	],
	"./hi/address": [
		23355,
		3355
	],
	"./hi/address.json": [
		23355,
		3355
	],
	"./hi/agriExpert": [
		79466,
		9466
	],
	"./hi/agriExpert.json": [
		79466,
		9466
	],
	"./hi/askQuestion": [
		49210,
		9210
	],
	"./hi/askQuestion.json": [
		49210,
		9210
	],
	"./hi/bankKyc": [
		78668,
		8668
	],
	"./hi/bankKyc.json": [
		78668,
		8668
	],
	"./hi/bioticStress": [
		65125,
		5125
	],
	"./hi/bioticStress.json": [
		65125,
		5125
	],
	"./hi/campaign": [
		98041,
		8041
	],
	"./hi/campaign.json": [
		98041,
		8041
	],
	"./hi/cart": [
		82497,
		2497
	],
	"./hi/cart.json": [
		82497,
		2497
	],
	"./hi/cartInsurance": [
		5693,
		5693
	],
	"./hi/cartInsurance.json": [
		5693,
		5693
	],
	"./hi/cattleInsurance": [
		65018,
		5018
	],
	"./hi/cattleInsurance.json": [
		65018,
		5018
	],
	"./hi/common": [
		44938,
		4938
	],
	"./hi/common.json": [
		44938,
		4938
	],
	"./hi/crop": [
		51605,
		1605
	],
	"./hi/crop.json": [
		51605,
		1605
	],
	"./hi/cropGuide": [
		6709,
		6709
	],
	"./hi/cropGuide.json": [
		6709,
		6709
	],
	"./hi/cropProblem": [
		25370,
		5370
	],
	"./hi/cropProblem.json": [
		25370,
		5370
	],
	"./hi/cropProblems": [
		97742,
		5361
	],
	"./hi/cropProblems.json": [
		97742,
		5361
	],
	"./hi/hospicash": [
		83177,
		3177
	],
	"./hi/hospicash.json": [
		83177,
		3177
	],
	"./hi/idKyc": [
		78509,
		8509
	],
	"./hi/idKyc.json": [
		78509,
		8509
	],
	"./hi/insurance": [
		68055,
		8055
	],
	"./hi/insurance.json": [
		68055,
		8055
	],
	"./hi/kyc": [
		10862,
		862
	],
	"./hi/kyc.json": [
		10862,
		862
	],
	"./hi/language": [
		36601,
		6601
	],
	"./hi/language.json": [
		36601,
		6601
	],
	"./hi/location": [
		37264,
		7264
	],
	"./hi/location.json": [
		37264,
		7264
	],
	"./hi/login": [
		25974,
		5974
	],
	"./hi/login.json": [
		25974,
		5974
	],
	"./hi/main": [
		8026,
		8026
	],
	"./hi/main.json": [
		8026,
		8026
	],
	"./hi/mandi": [
		1380,
		1380
	],
	"./hi/mandi.json": [
		1380,
		1380
	],
	"./hi/nearbyDc": [
		9301,
		9301
	],
	"./hi/nearbyDc.json": [
		9301,
		9301
	],
	"./hi/news": [
		10972,
		972
	],
	"./hi/news.json": [
		10972,
		972
	],
	"./hi/order": [
		28424,
		6043
	],
	"./hi/order.json": [
		28424,
		6043
	],
	"./hi/payments": [
		5360,
		5360
	],
	"./hi/payments.json": [
		5360,
		5360
	],
	"./hi/posts": [
		53508,
		3508
	],
	"./hi/posts.json": [
		53508,
		3508
	],
	"./hi/prakshep": [
		65763,
		5763
	],
	"./hi/prakshep.json": [
		65763,
		5763
	],
	"./hi/prescription": [
		87275,
		7275
	],
	"./hi/prescription.json": [
		87275,
		7275
	],
	"./hi/productFeed": [
		38816,
		8816
	],
	"./hi/productFeed.json": [
		38816,
		8816
	],
	"./hi/products": [
		41543,
		1543
	],
	"./hi/products.json": [
		41543,
		1543
	],
	"./hi/satellite": [
		68282,
		8282
	],
	"./hi/satellite.json": [
		68282,
		8282
	],
	"./hi/shriProgram": [
		3285,
		3285
	],
	"./hi/shriProgram.json": [
		3285,
		3285
	],
	"./hi/soilTest": [
		27256,
		7256
	],
	"./hi/soilTest.json": [
		27256,
		7256
	],
	"./hi/sowingDate": [
		14610,
		4610
	],
	"./hi/sowingDate.json": [
		14610,
		4610
	],
	"./hi/store": [
		75762,
		5762
	],
	"./hi/store.json": [
		75762,
		5762
	],
	"./hi/termSheet": [
		50618,
		618
	],
	"./hi/termSheet.json": [
		50618,
		618
	],
	"./mr/404": [
		7367,
		7367
	],
	"./mr/404.json": [
		7367,
		7367
	],
	"./mr/address": [
		55435,
		5435
	],
	"./mr/address.json": [
		55435,
		5435
	],
	"./mr/agriExpert": [
		78202,
		8202
	],
	"./mr/agriExpert.json": [
		78202,
		8202
	],
	"./mr/askQuestion": [
		82506,
		2506
	],
	"./mr/askQuestion.json": [
		82506,
		2506
	],
	"./mr/bankKyc": [
		94460,
		4460
	],
	"./mr/bankKyc.json": [
		94460,
		4460
	],
	"./mr/bioticStress": [
		64053,
		4053
	],
	"./mr/bioticStress.json": [
		64053,
		4053
	],
	"./mr/campaign": [
		89545,
		9545
	],
	"./mr/campaign.json": [
		89545,
		9545
	],
	"./mr/cart": [
		4241,
		4241
	],
	"./mr/cart.json": [
		4241,
		4241
	],
	"./mr/cartInsurance": [
		81485,
		1485
	],
	"./mr/cartInsurance.json": [
		81485,
		1485
	],
	"./mr/cattleInsurance": [
		30442,
		442
	],
	"./mr/cattleInsurance.json": [
		30442,
		442
	],
	"./mr/common": [
		90394,
		394
	],
	"./mr/common.json": [
		90394,
		394
	],
	"./mr/crop": [
		12581,
		2581
	],
	"./mr/crop.json": [
		12581,
		2581
	],
	"./mr/cropGuide": [
		20773,
		773
	],
	"./mr/cropGuide.json": [
		20773,
		773
	],
	"./mr/cropProblem": [
		22314,
		2314
	],
	"./mr/cropProblem.json": [
		22314,
		2314
	],
	"./mr/cropProblems": [
		84721,
		4721
	],
	"./mr/cropProblems.json": [
		84721,
		4721
	],
	"./mr/hospicash": [
		61209,
		1209
	],
	"./mr/hospicash.json": [
		61209,
		1209
	],
	"./mr/idKyc": [
		35037,
		5037
	],
	"./mr/idKyc.json": [
		35037,
		5037
	],
	"./mr/insurance": [
		20775,
		775
	],
	"./mr/insurance.json": [
		20775,
		775
	],
	"./mr/kyc": [
		35870,
		5870
	],
	"./mr/kyc.json": [
		35870,
		5870
	],
	"./mr/language": [
		24137,
		4137
	],
	"./mr/language.json": [
		24137,
		4137
	],
	"./mr/location": [
		87264,
		4883
	],
	"./mr/location.json": [
		87264,
		4883
	],
	"./mr/login": [
		44454,
		4454
	],
	"./mr/login.json": [
		44454,
		4454
	],
	"./mr/main": [
		59946,
		9946
	],
	"./mr/main.json": [
		59946,
		9946
	],
	"./mr/mandi": [
		92148,
		2148
	],
	"./mr/mandi.json": [
		92148,
		2148
	],
	"./mr/nearbyDc": [
		91333,
		1333
	],
	"./mr/nearbyDc.json": [
		91333,
		1333
	],
	"./mr/news": [
		1004,
		1004
	],
	"./mr/news.json": [
		1004,
		1004
	],
	"./mr/order": [
		1739,
		1739
	],
	"./mr/order.json": [
		1739,
		1739
	],
	"./mr/payments": [
		80512,
		512
	],
	"./mr/payments.json": [
		80512,
		512
	],
	"./mr/posts": [
		4116,
		4116
	],
	"./mr/posts.json": [
		4116,
		4116
	],
	"./mr/prakshep": [
		72723,
		2723
	],
	"./mr/prakshep.json": [
		72723,
		2723
	],
	"./mr/prescription": [
		17531,
		7531
	],
	"./mr/prescription.json": [
		17531,
		7531
	],
	"./mr/productFeed": [
		40912,
		912
	],
	"./mr/productFeed.json": [
		40912,
		912
	],
	"./mr/products": [
		24471,
		4471
	],
	"./mr/products.json": [
		24471,
		4471
	],
	"./mr/satellite": [
		20522,
		522
	],
	"./mr/satellite.json": [
		20522,
		522
	],
	"./mr/shriProgram": [
		5957,
		5957
	],
	"./mr/shriProgram.json": [
		5957,
		5957
	],
	"./mr/soilTest": [
		83592,
		3592
	],
	"./mr/soilTest.json": [
		83592,
		3592
	],
	"./mr/sowingDate": [
		22306,
		2306
	],
	"./mr/sowingDate.json": [
		22306,
		2306
	],
	"./mr/store": [
		48866,
		8866
	],
	"./mr/store.json": [
		48866,
		8866
	],
	"./mr/termSheet": [
		69418,
		9418
	],
	"./mr/termSheet.json": [
		69418,
		9418
	],
	"./or/404": [
		96845,
		6845
	],
	"./or/404.json": [
		96845,
		6845
	],
	"./or/address": [
		62469,
		2469
	],
	"./or/address.json": [
		62469,
		2469
	],
	"./or/agriExpert": [
		20328,
		328
	],
	"./or/agriExpert.json": [
		20328,
		328
	],
	"./or/askQuestion": [
		15684,
		5684
	],
	"./or/askQuestion.json": [
		15684,
		5684
	],
	"./or/bankKyc": [
		23422,
		3422
	],
	"./or/bankKyc.json": [
		23422,
		3422
	],
	"./or/bioticStress": [
		27427,
		7427
	],
	"./or/bioticStress.json": [
		27427,
		7427
	],
	"./or/campaign": [
		8527,
		8527
	],
	"./or/campaign.json": [
		8527,
		8527
	],
	"./or/cart": [
		48035,
		8035
	],
	"./or/cart.json": [
		48035,
		8035
	],
	"./or/cartInsurance": [
		23207,
		3207
	],
	"./or/cartInsurance.json": [
		23207,
		3207
	],
	"./or/cattleInsurance": [
		85960,
		5960
	],
	"./or/cattleInsurance.json": [
		85960,
		5960
	],
	"./or/common": [
		89724,
		9724
	],
	"./or/common.json": [
		89724,
		9724
	],
	"./or/crop": [
		55091,
		5091
	],
	"./or/crop.json": [
		55091,
		5091
	],
	"./or/cropGuide": [
		7235,
		7235
	],
	"./or/cropGuide.json": [
		7235,
		7235
	],
	"./or/cropProblem": [
		18016,
		8016
	],
	"./or/cropProblem.json": [
		18016,
		8016
	],
	"./or/cropProblems": [
		33607,
		3607
	],
	"./or/cropProblems.json": [
		33607,
		3607
	],
	"./or/hospicash": [
		53047,
		3047
	],
	"./or/hospicash.json": [
		53047,
		3047
	],
	"./or/idKyc": [
		67843,
		7843
	],
	"./or/idKyc.json": [
		67843,
		7843
	],
	"./or/insurance": [
		20745,
		745
	],
	"./or/insurance.json": [
		20745,
		745
	],
	"./or/kyc": [
		71060,
		1060
	],
	"./or/kyc.json": [
		71060,
		1060
	],
	"./or/language": [
		88087,
		8087
	],
	"./or/language.json": [
		88087,
		8087
	],
	"./or/location": [
		84538,
		4538
	],
	"./or/location.json": [
		84538,
		4538
	],
	"./or/login": [
		48032,
		8032
	],
	"./or/login.json": [
		48032,
		8032
	],
	"./or/main": [
		57400,
		7400
	],
	"./or/main.json": [
		57400,
		7400
	],
	"./or/mandi": [
		37750,
		5369
	],
	"./or/mandi.json": [
		37750,
		5369
	],
	"./or/nearbyDc": [
		20543,
		543
	],
	"./or/nearbyDc.json": [
		20543,
		543
	],
	"./or/news": [
		73322,
		941
	],
	"./or/news.json": [
		73322,
		941
	],
	"./or/order": [
		70829,
		829
	],
	"./or/order.json": [
		70829,
		829
	],
	"./or/payments": [
		98258,
		8258
	],
	"./or/payments.json": [
		98258,
		8258
	],
	"./or/posts": [
		8318,
		8318
	],
	"./or/posts.json": [
		8318,
		8318
	],
	"./or/prakshep": [
		80345,
		345
	],
	"./or/prakshep.json": [
		80345,
		345
	],
	"./or/prescription": [
		317,
		317
	],
	"./or/prescription.json": [
		317,
		317
	],
	"./or/productFeed": [
		3230,
		3230
	],
	"./or/productFeed.json": [
		3230,
		3230
	],
	"./or/products": [
		27273,
		7273
	],
	"./or/products.json": [
		27273,
		7273
	],
	"./or/satellite": [
		25380,
		5380
	],
	"./or/satellite.json": [
		25380,
		5380
	],
	"./or/shriProgram": [
		72827,
		2827
	],
	"./or/shriProgram.json": [
		72827,
		2827
	],
	"./or/soilTest": [
		34374,
		4374
	],
	"./or/soilTest.json": [
		34374,
		4374
	],
	"./or/sowingDate": [
		57864,
		5483
	],
	"./or/sowingDate.json": [
		57864,
		5483
	],
	"./or/store": [
		13020,
		3020
	],
	"./or/store.json": [
		13020,
		3020
	],
	"./or/termSheet": [
		43216,
		3216
	],
	"./or/termSheet.json": [
		43216,
		3216
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 68091;
module.exports = webpackAsyncContext;